<template>
  <div class="buy_user_box">
    <img
      v-if="userInfo.avatar_url" v-lazy="userInfo.avatar_url" class="user_avatar"
      alt="avatar">
    <span v-else class="user_avatar icon" />
    <span class="user_account">账户名称 ：{{ userInfo.username }}</span>
    <span>身份：{{ userInfo.privliegeName || '--' }}</span>
    <IconClose class="close_btn" @click.native="close" />
  </div>
</template>

<script>
import IconClose from '@/components/Icons/IconClose.vue'

export default {
  name: 'BuyUserInfo',

  components: { IconClose },

  computed: {
    userInfo () {
      return this.$store.state.userInfo
    }
  },

  methods: {
    close () {
      this.$emit('close')
    },

    reloadBuyDialog () {
      this.$emit('reloadBuyDialog')
    }
  }
}
</script>

<style lang="scss" scoped>
.buy_user_box { position: relative; height: 32px; font-size: 12px; font-weight: 500; line-height: 32px; color: #666;
  .user_avatar { display: inline-block; width: 24px; height: 24px; margin: -2px 0 0 4px; vertical-align: middle; background-size: cover; border-radius: 50%;
    &.icon { background-image: url(~@/assets/images/icon_avatar_gray.png); }
  }
  .user_account { margin: 0 38px 0 22px; }
  .close_btn { position: absolute; top: 0; right: 0; }
}
</style>
